// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SewerCameraInspectionPage from "../pages/SewerCameraInspection/SewerCameraInspection";
const __wvcRoutePaths = ["/SewerCameraInspectionPage", "/sewer-camera-inspection"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["4-point-inspection-in-south-florida", "broward-county-home-inspector", "browardcountyhomeinspectorpage", "condo-inspection", "condoinspectionpage", "florida-keys-home-inspector", "floridakeyshomeinspectorpage", "fourpointinspectionsouthfloridapage", "home", "home-inspection-in-homestead-fl", "home-inspection-service", "homeinspectioninhomesteadflpage", "homeinspectionservicepage", "homepage", "kendall-home-inspector", "kendallhomeinspectorpage", "miami-dade-county-home-inspector", "miami-home-inspector", "miamidadecountyhomeinspectorpage", "miamihomeinspectorpage", "mold-testing", "moldtestingpage", "new-construction-11-month-warranty-inspections", "newconstructioninspectionspage", "post", "pre-listing-inspection", "prelistinginspectionpage", "sewer-camera-inspection", "sewercamerainspectionpage", "wind-mitigation-inspection", "windmitigationinspectionpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<SewerCameraInspectionPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<SewerCameraInspectionPage />} />
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
